import { render } from "./TestStartController.vue?vue&type=template&id=38137b4a&scoped=true&ts=true"
import script from "./TestStartController.vue?vue&type=script&lang=ts"
export * from "./TestStartController.vue?vue&type=script&lang=ts"

import "./TestStartController.vue?vue&type=style&index=0&id=38137b4a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38137b4a"]])

export default __exports__